<template>
  <v-container fluid class="mx-0 px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-card flat class="mx-0 px-3 ntr-card-gray">
      <template v-if="isPrasymasIregistravimas">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Pardavėjo pareiškimas apie daiktą')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Pardavėjo pareiškimas apie daiktą`
              "
            />
          </v-col>
          <v-col cols="12" md="8">
            <el-autocomplete
              :readonly="isReadonly"
              :items="pareiskimasList"
              itemvalue="value"
              itemtext="text"
              validate-key="pareiskimas"
              hide-details="auto"
              multiple
              v-model="sutartis.sut_pareiskimas"
              @change="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Sutarties terminas iki (data)')
            }}<el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties terminas iki (data)`
              "
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :readonly="isReadonly"
              hide-details="auto"
              future-dates
              validate-key="sut_terminas_iki"
              v-model="sutartis.sut_terminas_iki"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Sutarties terminas iki (termino sąlyga)')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties terminas iki (termino sąlyga)`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_aprasymas"
              v-model="sutartis.sut_aprasymas"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Avanso suma, EUR')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. Avanso suma, EUR`"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-money-field
              :readonly="isReadonly"
              hide-details="auto"
              :precision="2"
              validate-key="sut_suma"
              v-model="sutartis.sut_suma"
              @blur="saveData()"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-checkbox
              :readonly="isReadonly"
              class="mt-4 ml-4"
              label="Įskaičiuotas PVM"
              :tooltip="`${ntrTooltipPrefix} Sutartis. Įskaičiuotas PVM`"
              v-model="sutartis.sut_iskaiciuotas_pvm"
              @click.native="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Avanso sumokėjimo data iki')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Avanso sumokėjimo data iki`
              "
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :readonly="isReadonly"
              hide-details="auto"
              validate-key="sut_perdavimo_data"
              v-model="sutartis.sut_perdavimo_data"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kita avanso mokėjimo informacija')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kita avanso mokėjimo informacija`
              "
              counter="4000"
              hide-details="auto"
              :rows="informacijaRows"
              :placeholder="placeholderMokejimoInformacija"
              validate-key="sut_mokejimo_informacija"
              v-model="sutartis.sut_mokejimo_informacija"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Pagrindinės sutarties notarinio tvirtinimo išlaidas apmoka')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Pagrindinės sutarties notarinio tvirtinimo išlaidas apmoka`
              "
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-autocomplete
              :readonly="isReadonly"
              :items="apmokaList"
              itemvalue="value"
              itemtext="text"
              validate-key="sut_apmoka_kla_id"
              hide-details="auto"
              v-model="sutartis.sut_apmoka_kla_id"
              @change="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kitos pagrindinės sutarties šalių numatytos sąlygos')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos pagrindinės sutarties šalių numatytos sąlygos`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_salygos"
              v-model="sutartis.sut_salygos"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
      </template>

      <template v-if="!isPrasymasIregistravimas">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t(' Sutarties numeris')
            }}<el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties numeris`"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="sut_numeris"
              v-model="sutartis.sut_numeris"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ sutartisDataLabel
            }}<el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. ${sutartisDataTooltip}`"
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="sut_data"
              v-model="sutartis.sut_data"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters v-if="isPrasymasIsregistravimas">
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Sutarties pabaigos data')
            }}<el-tooltip
              inline
              :tooltip="`${ntrTooltipPrefix} Sutartis. Sutarties pabaigos data`"
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-text-field
              :readonly="true"
              hide-details="auto"
              validate-key="sut_pabaigos_data"
              v-model="sutartis.sut_pabaigos_data"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters v-if="isPrasymasNutraukimas">
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Sutarties nutraukimo data')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Sutarties nutraukimo data`
              "
            />
          </v-col>
          <v-col cols="12" md="3" class="pr-5">
            <el-date-picker
              :readonly="isReadonly"
              hide-details="auto"
              validate-key="sut_nutraukimo_data"
              v-model="sutartis.sut_nutraukimo_data"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters v-if="isPrasymasNutraukimas">
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              need
              class="no-color-label"
              label="Avanso grąžinimo sąlygos"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Avanso grąžinimo sąlygos`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_avansas_grazinimas"
              v-model="sutartis.sut_avansas_grazinimas"
              @blur="saveData()"
            />
          </v-col>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              label="Kitos susitarimo sąlygos"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos susitarimo sąlygos`
              "
              counter="4000"
              hide-details="auto"
              validate-key="salygos"
              v-model="sutartis.sut_salygos"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
      </template>
    </v-card>

    <template v-if="isPrasymasIregistravimas">
      <h3 class="mt-4 mb-3">
        {{ $t('Šalių įsipareigojimai, jei nepasirašoma pagrindinė sutartis') }}
      </h3>
      <v-card flat class="mx-0 px-3 ntr-card-gray">
        <v-row dense no-gutters>
          <v-col class="bold-label pt-4" cols="12" md="4" align-self="center">
            {{ $t('Avanso grąžinimo k.d. skaičius')
            }}<el-need v-if="!isReadonly" /><el-tooltip
              inline
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Avanso grąžinimo k.d. skaičius`
              "
            />
          </v-col>
          <v-col cols="12" md="4">
            <el-text-field
              :readonly="isReadonly"
              hide-details="auto"
              v-mask="`###`"
              validate-key="sut_avansas_dienos"
              v-model="sutartis.sut_avansas_dienos"
              @blur="saveData()"
            >
            </el-text-field>
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kita avanso grąžinimo informacija')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kita avanso grąžinimo informacija`
              "
              counter="4000"
              :rows="informacijaRows"
              :placeholder="placeholderAvansasGrazinimas"
              hide-details="auto"
              validate-key="sut_avansas_grazinimas"
              v-model="sutartis.sut_avansas_grazinimas"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="
                $t(
                  'Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pardavėjo kaltės'
                )
              "
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pardavėjo kaltės`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_kalte_pardavejas"
              v-model="sutartis.sut_kalte_pardavejas"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="
                $t(
                  'Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pirkėjo kaltės'
                )
              "
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kitos sąlygos, jeigu pagrindinė sutartis nepasirašoma dėl pirkėjo kaltės`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_kalte_pirkejas"
              v-model="sutartis.sut_kalte_pirkejas"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kiti šalių įsipareigojimai')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kiti šalių įsipareigojimai`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_isipareigojimai"
              v-model="sutartis.sut_isipareigojimai"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
        <v-row dense no-gutters>
          <v-col cols="12" md="12" class="mt-5">
            <el-textarea
              :readonly="isReadonly"
              class="no-color-label"
              :label="$t('Kiti sutarties nutraukimo pagrindai')"
              :tooltip="
                `${ntrTooltipPrefix} Sutartis. Kiti sutarties nutraukimo pagrindai`
              "
              counter="4000"
              hide-details="auto"
              validate-key="sut_nutraukimo_pagrindai"
              v-model="sutartis.sut_nutraukimo_pagrindai"
              @blur="saveData()"
            />
          </v-col>
        </v-row>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import checkErrors from '@/mixins/checkErrors'

export default {
  name: 'PrasymasSutartisPreliminari',
  props: {
    readonly: { type: Boolean, default: false },
  },
  mixins: [userRole, busena, tooltipNtr, checkErrors],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      sutartis: {},
      pareiskimasList: [],
      apmokaList: [],
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isReadonly() {
      return this.readonly
    },
    tvirtinimoIslaidosList() {
      return [
        {
          value: 1,
          text: this.$t('Pirkėjas'),
        },
        {
          value: 2,
          text: this.$t('Pardavėjas'),
        },
        {
          value: 3,
          text: this.$t('Lygiomis dalimis'),
        },
        {
          value: 4,
          text: this.$t('Nenumatyta'),
        },
      ]
    },
    sutartisDataLabel() {
      if (this.isPrasymasIsregistravimas) {
        return this.$t('Sutarties pradžios data')
      }
      return this.$t('Sutarties data')
    },
    sutartisDataTooltip() {
      if (this.isPrasymasIsregistravimas) {
        return 'Sutarties pradžios data'
      }
      return 'Sutarties data'
    },
    informacijaRows() {
      if (this.isReadonly) {
        return 1
      }
      return 3
    },
    placeholderMokejimoInformacija() {
      if (this.isReadonly) {
        return ''
      }
      return (
        `Daikto1 unikalus numeris, avanso sumos dalis, banko sąskaita 1 Asmuo\n` +
        `Daikto2 unikalus numeris, avanso sumos dalis, banko sąskaita 2 Asmuo\n` +
        `Daikto3 unikalus numeris, avanso sumos dalis, banko sąskaita 3 Asmuo`
      )
    },
    placeholderAvansasGrazinimas() {
      if (this.isReadonly) {
        return ''
      }
      return (
        `Grąžinamo avanso sumos dalis, banko sąskaita 1 Asmuo\n` +
        `Grąžinamo avanso sumos dalis, banko sąskaita 2 Asmuo\n` +
        `Grąžinamo avanso sumos dalis, banko sąskaita 3 Asmuo`
      )
    },
  },
  created() {
    this.getKlasif()
  },
  methods: {
    getKlasif() {
      const data = {
        klasifikatoriai: [
          'preliminari_pardavejo_pareiskimas',
          'preliminari_apmoka',
        ],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.pareiskimasList = res.data.list.preliminari_pardavejo_pareiskimas
          this.apmokaList = res.data.list.preliminari_apmoka
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.getData()
        })
    },
    getData() {
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`)
        .then(res => {
          this.sutartis = res.data.sutartis

          this.updateErrors()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      if (this.isReadonly) {
        return
      }
      this.$validator.validateAll().then(res => {
        if (res) {
          const data = {
            ...this.sutartis,
          }
          this.$axios
            .post(`ntrpaslaugos/prasymas/${this.prasymasID}/sutartis`, data)
            .then(res => {
              this.updateErrors()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
  },
}
</script>
